import { render, staticRenderFns } from "./yi_print_template.vue?vue&type=template&id=6ce0afdc&scoped=true&"
import script from "./yi_print_template.vue?vue&type=script&lang=js&"
export * from "./yi_print_template.vue?vue&type=script&lang=js&"
import style1 from "./yi_print_template.vue?vue&type=style&index=1&lang=css&"
import style2 from "./yi_print_template.vue?vue&type=style&index=2&id=6ce0afdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce0afdc",
  null
  
)

export default component.exports